import { ITypedReduxAction } from '../../types/redux/actionType';
import { TSetNewAnswerFormOpenPayload } from './openFormActions';

export enum EOpenNewAnswerForm {
  Open = 'NEW_ANSWER/FORM/OPEN',
  Close = 'NEW_ANSWER/FORM/CLOSE',
}

export type TOpenNewAnswer = ITypedReduxAction<EOpenNewAnswerForm.Open, TSetNewAnswerFormOpenPayload>;
export type TCloseNewAnswer = ITypedReduxAction<EOpenNewAnswerForm.Close>;

export type TOpenNewAnswerFormActions = TOpenNewAnswer | TCloseNewAnswer;
